import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { DcRuntimeApi } from '@api/bff/openapi/endpoints/dc-runtime-api';
import type { DcRuntimeViewModel } from '@api/bff/openapi/models';
import { bffApiClient } from '@api/bff/client';
import { dcRuntimeKeys } from '../constants';
import { useApiToast } from '@hooks/useApiToast';

export const useDcRuntime = (id: string, enabled = true) => {
  const { showError } = useApiToast();
  const dcRuntimeApi = new DcRuntimeApi(undefined, undefined, bffApiClient);

  const query = useQuery<DcRuntimeViewModel, Error>({
    queryKey: dcRuntimeKeys.byId(id),
    queryFn: async () => {
      const response = await dcRuntimeApi.apiDcRuntimeIdGet({ id });
      return response.data;
    },
    enabled: enabled && !!id,
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000
  });

  useEffect(() => {
    if (query.error) {
      showError('calibrationRuntime.fetchError', query.error, 'calibrationApi');
    }
  }, [query.error, showError]);

  return query;
};
